import React, { ReactElement, useState } from "react";
import {
  Box,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  House,
  BusinessCenter,
  School,
  TravelExplore,
  Flag as FlagIcon,
  MonitorHeart as MonitorHeartIcon,
} from "@mui/icons-material";

import { useNavigate } from "react-router-dom";
import { authContext } from "../Context/Authentication/authContext";
import splashImage from "../assets/splash2.jpeg";
import MapIcon from "../assets/Geography-Splash.png";
import "./Roseville.scss";
import Chat from "../Chat1/Chat";
import ModestoChat from "../Chat1/ModestoChat";
import Draggable from "react-draggable";
import { Resizable } from "re-resizable";

const INITIAL_VALUES = {
  population: false,
  economy: false,
  education: false,
  housing: false,
};

// @ts-ignore
const Roseville = (props: any): ReactElement => {
  const navigate = useNavigate();
  const { dispatch, state }: any = React.useContext(authContext);
  const [openChatWindow, setOpenChatWindow] = useState(false);
  const [value, setValue] = React.useState(INITIAL_VALUES);

  const handleChange = (val: any) => {
    const data = { ...INITIAL_VALUES };
    // @ts-ignore
    data[val] = true;
    setValue(data);
  };

  const handleClose = () => {
    // setAnchorEl(null);
    setOpenChatWindow(false);
  };

  return (
    <div className="geo-container">
      <div className="splash cp-hero">
        <div className="image-container">
          <img src={splashImage} className="image" />
        </div>
        <div className="content-container">
          <h1 className="profile-title">
            <p>Roseville, CA</p>
          </h1>
        </div>
        <div className="content-container">
          <div className="profile-subtitle">
            <p
              className="profile-subtitle-button"
              onClick={() => navigate("/report")}
            >
              <img src={MapIcon} className="image" /> Metropolitan Analysis
            </p>
          </div>
        </div>
        <div className="content-container">
          <div className="profile-stats">
            <div className="stat large-text">
              <div className="stat-title">2020 Population</div>
              <div className="stat-value">138,860</div>
              <div className="stat-subtitle">2.38% 1-year growth</div>
            </div>
            <div className="stat small-text">
              <div className="stat-title">US Senator</div>
              <div className="stat-value">
                <span
                  className="candidate-image"
                  style={{ borderColor: "#142E58" }}
                >
                  <span
                    style={{
                      backgroundImage:
                        "url('https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Dianne_Feinstein%2C_official_Senate_photo_2_%28cropped%29.jpg/95px-Dianne_Feinstein%2C_official_Senate_photo_2_%28cropped%29.jpg')",
                    }}
                  ></span>
                </span>
                <span className="candidate-name">Dianne Feinstein</span>
              </div>
              <div className="stat-subtitle">Democratic Party</div>
            </div>
            <div className="stat small-text">
              <div className="stat-title">US Senator</div>
              <div className="stat-value">
                <span
                  className="candidate-image"
                  style={{ borderColor: "#142E58" }}
                >
                  <span
                    style={{
                      backgroundImage:
                        "url('https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Alex_Padilla_117th_Congress_portrait_%28cropped%29.jpg/95px-Alex_Padilla_117th_Congress_portrait_%28cropped%29.jpg')",
                    }}
                  ></span>
                </span>
                <span className="candidate-name">Alex Padilla</span>
              </div>
              <div className="stat-subtitle">Democratic Party</div>
            </div>
            <div className="stat large-text">
              <div className="stat-title">2020 Median Age</div>
              <div className="stat-value">39.1</div>
              <div className="stat-subtitle">1.56% 1-year increase</div>
            </div>
            <div className="stat large-text">
              <div className="stat-title">2020 Poverty Rate</div>
              <div className="stat-value">7.5%</div>
              <div className="stat-subtitle">10.8% 1-year decrease</div>
            </div>
            <div className="stat large-text">
              <div className="stat-title">2020 Median Household Income</div>
              <div className="stat-value">$95,519</div>
              <div className="stat-subtitle">7.23% 1-year growth</div>
            </div>
            <div className="stat large-text">
              <div className="stat-title">2020 Median Property Value</div>
              <div className="stat-value">$473,300</div>
              <div className="stat-subtitle">6.5% 1-year growth</div>
            </div>
            <div className="stat large-text">
              <div className="stat-title">2020 Employed Population</div>
              <div className="stat-value">66,898</div>
              <div className="stat-subtitle">3.36% 1-year growth</div>
            </div>
          </div>
        </div>
      </div>
      <Box component="nav" className="cp-subnav is-static">
        <List className="cp-subnav-list">
          <ListItem className="cp-subnav-item">
            <Link
              href="#"
              component="button"
              className={`cp-subnav-link u-font-xs ${
                value["population"] ? "is-active" : "is-inactive"
              }`}
              onClick={() => {
                handleChange("population");
              }}
            >
              <ListItemIcon>
                <TravelExplore className="cp-subnav-link-icon" />
              </ListItemIcon>
              <ListItemText primary="Population & Diversity" />
            </Link>
          </ListItem>
          <ListItem className="cp-subnav-item">
            <Link
              href="#"
              component="button"
              className={`cp-subnav-link u-font-xs ${
                value["economy"] ? "is-active" : "is-inactive"
              }`}
              onClick={() => {
                handleChange("economy");
              }}
            >
              <ListItemIcon>
                <BusinessCenter className="cp-subnav-link-icon" />
              </ListItemIcon>
              <ListItemText primary="Economy" />
            </Link>
          </ListItem>
          <ListItem className="cp-subnav-item">
            <Link
              href="#"
              component="button"
              className={`cp-subnav-link u-font-xs ${
                value["education"] ? "is-active" : "is-inactive"
              }`}
              onClick={() => {
                handleChange("education");
              }}
            >
              <ListItemIcon>
                <FlagIcon className="cp-subnav-link-icon" />
              </ListItemIcon>
              <ListItemText primary="Civics" />
            </Link>
          </ListItem>
          <ListItem className="cp-subnav-item">
            <Link
              href="#"
              component="button"
              className={`cp-subnav-link u-font-xs ${
                value["education"] ? "is-active" : "is-inactive"
              }`}
              onClick={() => {
                handleChange("education");
              }}
            >
              <ListItemIcon>
                <School className="cp-subnav-link-icon" />
              </ListItemIcon>
              <ListItemText primary="Education" />
            </Link>
          </ListItem>
          <ListItem className="cp-subnav-item">
            <Link
              href="#"
              component="button"
              className={`cp-subnav-link u-font-xs ${
                value["housing"] ? "is-active" : "is-inactive"
              }`}
              onClick={() => {
                handleChange("housing");
              }}
            >
              <ListItemIcon>
                <House className="cp-subnav-link-icon" />
              </ListItemIcon>
              <ListItemText primary="Housing & Living" />
            </Link>
          </ListItem>
          <ListItem className="cp-subnav-item">
            <Link
              href="#"
              component="button"
              className={`cp-subnav-link u-font-xs ${
                value["education"] ? "is-active" : "is-inactive"
              }`}
              onClick={() => {
                handleChange("education");
              }}
            >
              <ListItemIcon>
                <MonitorHeartIcon className="cp-subnav-link-icon" />
              </ListItemIcon>
              <ListItemText primary="Health" />
            </Link>
          </ListItem>
        </List>
      </Box>
      <Draggable defaultClassName={!openChatWindow ? "draggable-chat" : ""}>
        <Resizable
          defaultSize={{
            width: 512,
            height: "82%",
          }}
          className={
            openChatWindow
              ? `swipeWrapper-container swipeWrapper-container__open`
              : `swipeWrapper-container swipeWrapper-container__hidden`
          }
          style={{
            transition: openChatWindow ? "none" : "all 4s ease",
            zIndex: openChatWindow ? 9999 : 0,
            right: 0,
            position: "absolute",
          }}
        >
          <div
            className={
              openChatWindow
                ? `swipeWrapper-container__innerContainer swipeWrapper-container__open`
                : `swipeWrapper-container__innerContainer swipeWrapper-container__hidden`
            }
            style={{
              // background: `url(${backgroundImage ? backgroundImage : bg})`,
              transition: `all 2s ease`,
              background: "#fff",
            }}
          >
            <ModestoChat
              selectedState={"chat"}
              open={openChatWindow}
              handleClose={handleClose}
            />
          </div>
        </Resizable>
      </Draggable>
      {!openChatWindow && (
        <div
          className="geo-container__chatAIButtonContainer"
          onClick={() => setOpenChatWindow(true)}
        >
          <div className="geo-container__chatAIButtonContainer__button">AI</div>
        </div>
      )}
    </div>
  );
};

export default Roseville;